import CrudTab from "@/components/CrudTab";

const TYPES = [{ value: "income", label: "Income" }, { value: "expense", label: "Expense" }];
const FIELDS = [
  { key: "name", label: "Name", type: "text" },
  { key: "type", label: "Type", type: "select", options: TYPES },
  { key: "active", label: "Active", type: "switch" },
];
const TypeChip = ({ type }) => (
  <span className={`inline-block px-2 py-0.5 text-xs font-mono uppercase border ${type === "income" ? "border-emerald-500/40 text-emerald-300" : "border-rose-500/40 text-rose-300"}`}>
    {type}
  </span>
);
const COLUMNS = [
  { key: "name", label: "Category" },
  { key: "type", label: "Type", render: (r) => <TypeChip type={r.type} /> },
];

export default function CategoriesTab() {
  return (
    <CrudTab table="categories" singular="Category" prefix="category" fields={FIELDS} columns={COLUMNS}
      blank={{ name: "", type: "income", active: true }} />
  );
}
